module.exports = __webpack_public_path__ + "static/media/mssg_getstartedresponse_pt_PT.a20dea58.png";